import React, { useState } from "react";
import "./Footer.css";
import {Button, Slider, Checkbox, Dropdown_aspect, ColorPicker,} from "../../../Components/";
import { useSelector, useDispatch } from "react-redux";
import {updateSettingOptionState, saveProjectSettings,} from "../../../Redux/actions/projectActions";
import CloneProjectModal from "../CloneProject/CloneProjectModal";
import Render from "../Render/Render";
import RenderNew from "../Render/RenderNew";
import { setGlobalColorInReudx } from "../../../Redux/actions/commonActtion";
const debounceTimeoutIds = {};
const Footer = ({ currentBlockOptions, isTitleSafe, setIsTitleSafe, getBlockSize, aspectRatio_FrameSize, setAspectRatio_FrameSize, handleFooterClick }) => {
  const dispatch = useDispatch();
  const [selectedID, setSelectedID] = useState('')
  const { currentBlock } = useSelector((state) => state?.project);
  const projectSettings = useSelector((state) => state.project.settings);
  const [renderOpen, setRenderOpen] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [options, setOptions] = useState([{ label: "NONE", value: "hdnone" },
  { label: "1.33", value: "Class1x33" },
  { label: "1.78", value: "Class1x78" },
  { label: "1.85", value: "Class1x85" },
  { label: "1.9", value: "Class1x9" },
  { label: "2.35", value: "Class2_35x1" },
  { label: "2.39", value: "Class2x39" },]);

  const { gobalBGcolor } = useSelector((state) => state?.commonReducer);
  const updateProjectSettingsState = (key, value) => dispatch(updateSettingOptionState(key, value));
  const saveProjectSettingsCall = () => dispatch(saveProjectSettings());
  // const debouncedSettingsSave = debounce(saveProjectSettingsCall, 1000);
  const debouncedSave = (key, value) => {
    if (debounceTimeoutIds[key]) {
      clearTimeout(debounceTimeoutIds[key]);
      debounceTimeoutIds[key] = null;
    }
    debounceTimeoutIds[key] = setTimeout(() => {
      saveProjectSettingsCall(key, value);
    }, 1500);
  }

  return (
    <div className="main-footer pl-[2%] pr-[1.6%]">
      <div className="leftBottom"></div>
      <div className="centerBottom ">
        {/* BG Global Color code start here */}
        {/* <div className="Gutter">
          <div >
            <input
              type="color"
              className="colorPickerLabel"
              value={gobalBGcolor}
              onChange={(evt) => {
                dispatch(setGlobalColorInReudx(evt.target.value));
              }}
              onBlur={() => dispatch(setGlobalColorInReudx(gobalBGcolor))}
            />
            <input
              type="text"
              id="colors"
              className="colorPickerInputsText drop-shadow-2xl"
              name="color"
              value={gobalBGcolor}
              onChange={(evt) => {
                dispatch(setGlobalColorInReudx(evt.target.value));
              }}
              onBlur={() => dispatch(setGlobalColorInReudx(gobalBGcolor))}
            />
          </div>
        </div> */}
        {
          currentBlockOptions?.text_alignment === "ragged" ? (
            <div className="Gutter">
              <span>Ragged Gutter</span>
              <div className="Gutter-input ">
                <Slider
                  value={projectSettings?.ragged_gutter}
                  handleChange={(val) => {
                    updateProjectSettingsState("ragged_gutter", val);
                    debouncedSave();
                  }}
                />
                <hr />
              </div>
            </div>
          ) : (
            ((currentBlockOptions?.text_alignment === "center" ||
              currentBlockOptions?.text_alignment === "gutter") ? (<div className="Gutter">
                <span>Gutter</span>
                <div className="Gutter-input ">
                  <Slider
                    value={projectSettings?.gutter}
                    handleChange={(val) => {
                      updateProjectSettingsState("gutter", val);
                      debouncedSave();
                    }}
                  />
                  <hr />
                </div>
              </div>) : (null)
            ))
        }
        {/* <div className="Aspect-ratio">
          <Dropdown
            // option={AspectRatio}
            selectRatio={selectRatio}
            setSelectRatio={setSelectRatio}
            label={"Aspect ratio"}
          />
        </div> */}


        <div className="Aspect-ratio  items-center justify-center">
          <div className="w-full  px-3 border-r-[2px] border-[#a1a1a2]  h-[15px]">
            <Dropdown_aspect
              options={options}
              value={aspectRatio_FrameSize}
              aspectRatio_FrameSize={aspectRatio_FrameSize}
              setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              label={"Aspect ratio"}
              selectedID={selectedID}
              onChange={(value) => {
                getBlockSize("aspectRatio_frame", value);

                const idx = options.findIndex((opt) => opt.value === value);
                if (idx !== -1) {
                  setSelectedID(idx)
                }
                // if (idx !== -1) {
                //   const updatedOptions = [
                //     options[idx],   
                //     ...options.slice(0, idx), 
                //     ...options.slice(idx + 1),
                //   ];

                //   setOptions(updatedOptions);
                // }
              }}
            />
          </div>

        </div>

        {/* <div className="Screen-bounds">
          <Checkbox label={"Screen bounds"} isScrBound={isScrBound} setIsScrBound={setIsScrBound} />
        </div> */}

        <div className="Title-safe">
          <Checkbox label={"Title safe"} isTitleSafe={isTitleSafe} setIsTitleSafe={setIsTitleSafe} />
        </div>

      </div>

      <div className="rightBottom">
        {/* <Button
         type="button"
         buttonStyle="btn--solid"
         buttonSize="btn--size"
         onClick={handleFooterClick}
        >
          <span className="uppercase Syne700">Preview</span>          
        </Button> */}


        <Button
          onClick={() => setRenderOpen(true)}
          type="button"
          buttonStyle="btn--solid"
          buttonSize="btn--size"
        >         
          <span className="uppercase  Syne700">Render</span>
        </Button>
      </div>
      <CloneProjectModal
        projectCloneModalOpen={projectCloneModalOpen}
        setProjectCloneModalOpen={setProjectCloneModalOpen}
      />
      {/* {renderOpen && <Render
        renderOpen={renderOpen}
        setRenderOpen={setRenderOpen}
        currentBlockIdx={currentBlock?.idx}
      />} */}

      {renderOpen && <RenderNew
        renderOpen={renderOpen}
        setRenderOpen={setRenderOpen}
        currentBlockIdx={currentBlock?.idx}
      />}
    </div>
  );
};

export default Footer;
